module.exports = __webpack_public_path__ + "static/media/Edit.b2fceb95.svg";